module.exports = __webpack_public_path__ + "img/finance_persediaan.7c2d9979.svg";